<template>
  <v-app>
   <div class="map-container">
     <gmap-map
         @zoom_changed="updateMapBounds"
         @dragend="updateMapBounds"
         :zoom="$store.state.mainMapZoom"
         :center="$store.state.mainMapCenter"
         class="map"
         :options="{
           gestureHandling: 'greedy',
           disableDefaultUI: true,
           clickableIcons: false,
           restriction: {
              latLngBounds: {
                  north: 85,
                  south: -85,
                  west: -180,
                  east: 180
              }
          },
         }"
         id="mainMap"
         ref="mapRef" >

       <div v-if="bottomDrawerContent === 1">
         <gmap-marker :key="index" v-for="(m, index) in $store.state.myLocations"
                        :position="m.position"
                        @click="center=m.position"
                        :icon="{
                          url: require('@/assets/marker'+ Math.floor((Math.random() * 3)+1) +'.webp'), // Use require() to specify the icon URI
                          scaledSize: new google.maps.Size(35, 40)
                        }"
         ></gmap-marker>
       </div>
       <div v-if="bottomDrawerContent === 0">
         <gmap-cluster :calculator="globalClusterCalculator" key="0">
           <gmap-marker :key="index" v-for="(m, index) in $store.state.topLocations"
                        :position="m.position"
                        @click="$store.dispatch('openTopLocationDialog', m)"
                        :label="{
                          text: m.nomad_count.toString(),
                          fontSize: '18px',
                          fontWeight: 'bold',
                          color: 'black',
                        }"
                        :animation="google.maps.Animation.DROP"
                        :icon="{
                          url: require('@/assets/marker'+ Math.floor((Math.random() * 3)+5) +'.webp'), // Use require() to specify the icon URI
                          scaledSize: new google.maps.Size(35, 40),
                          labelOrigin: new google.maps.Point(18, 17)
                        }"
           ></gmap-marker>
         </gmap-cluster>
       </div>
       <div v-if="bottomDrawerContent === 2 && $store.state.hotSpots.length > 0">
         <gmap-cluster :calculator="globalClusterCalculator"  @click="hotspotsClusterClick" :gridSize="20" averageCenter key="2">
           <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"></gmap-info-window>
           <gmap-marker :key="index"
                        v-for="(m, index) in $store.state.hotSpots"
                        :position="m.geometry.location"
                        :animation="google.maps.Animation.DROP"
                        @click="toggleInfoWindow(m)"
                        :icon="{
                          url: require('@/assets/hotspotMarker.png'), // Use require() to specify the icon URI
                          scaledSize: new google.maps.Size(35, 40), // Adjust the size as needed
                          labelOrigin: new google.maps.Point(17, 13)
                        }"
                        :label="{
                          text: m.rating.toString(),
                          fontSize: '12px',
                          fontWeight: 'bold',
                        }">
           </gmap-marker>
         </gmap-cluster>
       </div>
<!--        <div v-if="bottomDrawerContent === 4 && $store.state.socialData">-->
<!--          <gmap-cluster :calculator="globalClusterCalculator" @click="hotspotsClusterClick" key="4">-->
<!--            <gmap-marker :key="index" v-for="(m, index) in $store.state.socialData" :position="m.locations.position" :animation="google.maps.Animation.DROP"></gmap-marker>-->
<!--          </gmap-cluster>-->
<!--        </div>-->
       <div v-if="bottomDrawerContent === 4 && $store.state.socialData">
         <gmap-cluster :calculator="globalClusterCalculator" @click="hotspotsClusterClick" key="4" :gridSize="35" averageCenter>
           <gmap-marker :key="index" v-for="(m, index) in $store.state.socialData" :position="m.location_id.position" :animation="google.maps.Animation.DROP" @click="openSocialEventDialog(m)"></gmap-marker>
         </gmap-cluster>
       </div>
     </gmap-map>
   </div>


  <v-card ref="drawer" class="blue lighten-4 rounded-t-xl drawerCard" :height="drawerHeight" :max-height="maxDrawerHeight" v-bind:class="{'closedDrawer noScroll': !drawerOpen}" >
    <div style="display: flex;" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
      <div ref="handle" class="drawer-handle" ></div>
    </div>

    <div class="topLocationSection" v-if="bottomDrawerContent===0">
      <v-card-title class="drawerTitle" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">Top Destinations</v-card-title>
      <TopLocations></TopLocations>
    </div>

    <div class="myLocationSection" v-if="bottomDrawerContent===1">
      <v-card-title class="drawerTitle" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">My Journey</v-card-title>
      <MyLocations :drawerOpen="drawerOpen"></MyLocations>
    </div>

    <div class="aroundYouSection " v-if="bottomDrawerContent===2">
      <v-card-title class="drawerTitle" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" v-if="$store.state.hotspotType" style="text-transform: capitalize">
        {{ $store.state.hotspotType }}s Around You</v-card-title>
      <v-card-title class="drawerTitle" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" v-else>HotSpots Around You</v-card-title>
      <HotSpots :drawerOpen="drawerOpen" :mapObject="this.$refs.mapRef.$mapObject" @hotspotClick="hotspotClick" @closeInfoWindow="closeInfoWindow"></HotSpots>
    </div>

<!--    <div class="exploreSection" v-if="bottomDrawerContent===3">-->
<!--      <v-card-title class="drawerTitle" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">Explore</v-card-title>-->
<!--      <GlobalSearch></GlobalSearch>-->
<!--    </div>-->

    <v-dialog v-model="$store.state.exploreViewVisible" fullscreen transition="slide-x-reverse-transition" class="blue lighten-4" style="width: 100%">
      <GlobalSearch></GlobalSearch>
    </v-dialog>

    <div class="exploreSection" v-if="bottomDrawerContent===4">
      <v-card-title class="drawerTitle" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">Community</v-card-title>
      <SocialData :drawerOpen="drawerOpen" @openDrawer="openDrawer"></SocialData>
    </div>

  </v-card>
  <v-app-bar elevation="4" bottom fixed class="rounded-t-lg" color="#EEEEEE">
    <div v-if="$store.state.eventsVisible" @click="changeBottomDrawerContent(4)">
      <v-icon size="22" :color="bottomDrawerContent === 4 ? 'blue' : ''">mdi-star</v-icon>
      <v-card-subtitle v-bind:class="{'blueColor': bottomDrawerContent === 4}" class="pa-0 ma-0 bottomBarText">Community</v-card-subtitle>
    </div>
    <v-spacer></v-spacer>
    <div @click="changeBottomDrawerContent(0)">
      <v-icon size="22" :color="bottomDrawerContent === 0 ? 'blue' : ''">mdi-trophy</v-icon>
      <v-card-subtitle v-bind:class="{'blueColor': bottomDrawerContent === 0}" class="pa-0 ma-0 bottomBarText">Destinations</v-card-subtitle>
    </div>

    <v-spacer></v-spacer>
    <div @click="changeBottomDrawerContent(1)">
      <v-icon size="22" :color="bottomDrawerContent === 1 ? 'blue' : ''">mdi-map-marker-path</v-icon>
      <v-card-subtitle v-bind:class="{'blueColor': bottomDrawerContent === 1}" class="pa-0 ma-0 bottomBarText">Journey</v-card-subtitle>
    </div>
    <v-spacer></v-spacer>
    <div @click="changeBottomDrawerContent(2)">
      <v-icon size="22" :color="bottomDrawerContent === 2 ? 'blue' : ''">mdi-map-marker-star</v-icon>
      <v-card-subtitle v-bind:class="{'blueColor': bottomDrawerContent === 2}" class="pa-0 ma-0 bottomBarText">Hotspots</v-card-subtitle>
    </div>
    <v-spacer></v-spacer>
    <div @click="changeBottomDrawerContent(3)">
      <v-icon size="22" :color="bottomDrawerContent === 3 ? 'blue' : ''">mdi-magnify</v-icon>
      <v-card-subtitle v-bind:class="{'blueColor': bottomDrawerContent === 3}" class="pa-0 ma-0 bottomBarText">Explore</v-card-subtitle>
    </div>
<!--    <v-spacer v-if="$store.state.eventsVisible"></v-spacer>-->
  </v-app-bar>
  <LocationDialog></LocationDialog>
  <v-alert transition="scroll-y-transition" dismissible v-model="$store.state.addLocationErrorAlert" type="error" color="red" dense origin="top" class="badAlert">
    Error Adding Your Location
  </v-alert>
 </v-app>
</template>

<script>
import Vue from "vue";
import {gmapApi} from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

import TopLocations from "@/components/TopLocations.vue";
import MyLocations from "@/components/MyLocations.vue";
import LocationDialog from "@/components/LocationDialog.vue";
import {store} from "@/store";
import GlobalSearch from "@/components/GlobalSearch.vue";
import SocialData from "@/components/SocialData.vue";
import HotSpots from "@/components/HotSpots.vue";
import ViewportControlMixin from '@/mixins/ViewportControlMixin';


Vue.component('GmapCluster', GmapCluster)

  export default {
    name: "MapComponent",
    components: {HotSpots, SocialData, GlobalSearch, MyLocations,  TopLocations, LocationDialog},
    data() {
      return {
        globalMap: document.getElementById('mainMap'),
        locationNomads: [],
        dialogLocation: {"locationName":" , "},
        topLocationDialogLocation: {"locationName":" , "},
        topLocationDialogVisible: false,
        bottomDrawerContent: 4,
        drawerOpen: false,
        maxDrawerHeight: "60vh",
        startY: 0,
        center: {
          lat: 27.7837304,
          lng: 16.4458825
        },

        existingPlace: null,
        userProfileData: {},
        userProfileDepartureDate: null,


        currentY: 0,
        drawerHeight: 0,
        screenHeight: 0,
        isDragging: false,

        infoWindowPos: null,
        infoWinOpen: false,
        currentMid: null,
        infoOptions: {
          content: '',
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
      }
    },
    mixins: [ViewportControlMixin],
    watch: {
      bottomDrawerContent: {
        handler: function (newVal) {
          if (newVal === 2) {
            store.commit('changeHotSpotsChipsState', true)
          } else {
            store.commit('changeHotSpotsChipsState', false)
          }
        }
      },
      mapObject: {
        handler: function (newVal) {
          console.log(newVal)
        },
        deep: true
      },
    },
    computed: {
      google: gmapApi,
    },

    created() {
      this.checkMapBounds();
    },

    mounted() {
      this.screenHeight = window.innerHeight;
      this.drawerHeight = this.screenHeight * 0.25;
    },
    methods: {
      checkMapBounds() {
        if (this.$refs.mapRef && this.$refs.mapRef.$mapObject && this.$refs.mapRef.$mapObject.getBounds()) {
          store.commit('setMapBounds', this.$refs.mapRef.$mapObject.getBounds())
          store.commit('loadingOff')
        } else {
          setTimeout(this.checkMapBounds, 500); // Adjust delay as needed
        }
      },
      openSocialEventDialog(itemData) {
        console.log(itemData)
        store.commit('setSocialEvent', itemData)
      },
      hotspotClick(placeData) {
        this.drawerHeight = this.screenHeight * 0.28;
        this.toggleInfoWindow(placeData)
      },
      mapObject() {
        return this.$refs.mapRef ? this.$refs.mapRef.$mapObject : null;
      },
      hotspotsClusterClick(cluster) {
        store.commit('changeMapCenter', cluster.center_)
        let newZoom = store.state.mainMapZoom + 1
        store.commit('changeMapZoom', newZoom)
        store.commit('setViewsMapZoom', newZoom)

      },
      changeBottomDrawerContent(newVal) {
        if (newVal === this.bottomDrawerContent && newVal === 3) {
          store.commit('setExploreViewVisibility', true)
        }
        else if (newVal === this.bottomDrawerContent) {
          this.toggleDrawer()
        } else {
          let mapObject = this.$refs.mapRef.$mapObject
          let mapCenter = mapObject.center
          let mapZoom = mapObject.zoom

          store.commit('setViewsMapCenter', {view: this.bottomDrawerContent, value: mapCenter})
          store.commit('setViewsMapZoom', {view: this.bottomDrawerContent, value: mapZoom})

          this.bottomDrawerContent = newVal
          if (store.state.viewsMapCenter[newVal]) {
            store.commit('changeMapCenter', store.state.viewsMapCenter[newVal]);
            store.commit('changeMapZoom', store.state.viewsMapZoom[newVal]);
          }
          if (this.bottomDrawerContent === 3) {
            this.drawerHeight = 0;
            this.drawerOpen = false
            store.commit('setExploreViewVisibility', true)
            return
          }
          if (this.drawerHeight < this.screenHeight * 0.25) {
            this.drawerHeight = this.screenHeight * 0.25;
            this.drawerOpen = true
          }
        }
      },
      mapZoomChanged() {
        this.updateMapBounds()
      },
      updateMapBounds() {
        // Ensure the map reference is available
        if (!this.$refs.mapRef || !this.$refs.mapRef.$mapObject) return;
        store.commit('setMapBounds', this.$refs.mapRef.$mapObject.getBounds())
      },
      closeInfoWindow() {
        this.infoWinOpen = false;
      },
      toggleInfoWindow(marker) {
        this.infoWindowPos = marker.geometry.location;
        this.infoOptions.content = `<a style="color: black!important;" class="infoWindowText" href="https://www.google.com/maps/search/?api=1&query=${marker.name}&query_place_id=${marker.place_id}">${marker.name}</a>`

        if (this.currentMid === marker.place_id) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMid = marker.place_id;
        }
      },
      openInGoogleMaps(placeId) {
        const url = `https://www.google.com/maps/place/?q=place_id:${placeId}`;
        window.open(url, '_blank');
      },

      globalClusterCalculator(markers) {
        if (this.bottomDrawerContent === 0) {
          const sum = markers.reduce((total, obj) => total + parseInt(obj.label.text), 0);
          return  { text: sum.toString(), index: 1 }
        } else if (this.bottomDrawerContent === 2 || this.bottomDrawerContent === 4) {
          const count = markers.length;
          return {text: count.toString(), index: 1};
        }
      },

      // clusterCalculator(markers) {
      //   console.log(markers)
      //   const sum = markers.reduce((total, obj) => total + parseInt(obj.label), 0);
      //   let res = { text: sum.toString(), index: 1 }
      //   console.log(res)
      //   return res;
      // },
      //
      // eventsClusterCalculator(markers) {
      //   const count = markers.length;
      //   const result = { text: count.toString(), index: 1 };
      //   return result;
      // },

      handleTouchStart(event) {
        event.stopPropagation();
        this.startY = event.touches[0].clientY;
        this.isDragging = true;
      },
      handleTouchMove(event) {
        event.stopPropagation();
        event.preventDefault();
        if (!this.isDragging) return;

        this.currentY = event.touches[0].clientY;
        let deltaY = this.currentY - this.startY;
        let newHeight = this.drawerHeight - deltaY;
        if (newHeight > this.screenHeight * 0.5) {
          newHeight = this.screenHeight * 0.5; // Limit to 50% of the screen height
        } else if (newHeight < this.screenHeight * 0.1) {
          newHeight = this.screenHeight * 0.1; // Minimum 10% of the screen height
        }
        this.drawerHeight = newHeight;
         // Reset the start position for the next move event
      },
      // handleTouchEnd(event) {
      //   event.stopPropagation();
      //
      //   this.isDragging = false;
      //   if (this.drawerHeight > this.screenHeight * 0.25) {
      //     this.drawerHeight = this.screenHeight * 0.48; // Snap to 50% if ended above the 25% mark
      //     this.drawerOpen = true
      //   } else {
      //     this.drawerHeight = 0; // Snap to 10% if ended below the 25% mark
      //     this.drawerOpen = false
      //   }
      // },
      handleTouchEnd(event) {
        event.stopPropagation();
        this.isDragging = false;
        let deltaY = this.startY - event.changedTouches[0].clientY;
        console.log(deltaY)
        const swipeThreshold = -30; // Adjust threshold as needed

        if (deltaY < swipeThreshold) {
          this.drawerHeight = 0;
          this.drawerOpen = false;
        } else if (deltaY > -swipeThreshold) {
          this.drawerHeight = this.screenHeight * 0.48;
          this.drawerOpen = true;
        }
        this.startY = this.currentY;
      },
      toggleDrawer() {
        if (this.drawerHeight <= this.screenHeight * 0.25) {
          this.drawerHeight = this.screenHeight * 0.48;
          this.drawerOpen = true
        } else {
          this.drawerHeight = 0;
          this.drawerOpen = false
        }
      },
      openDrawer() {
        if (this.drawerHeight <= this.screenHeight * 0.25) {
          this.drawerHeight = this.screenHeight * 0.25;
          this.drawerOpen = true
        }
      },
    },
  }
</script>

<style>
.gm-style iframe + div { border:none!important; }

.blueColor {
  color: #2196F3;
}

.badAlert {
  top: 10vh;
  width: 75vw;
  text-align: center;
  position: fixed;
  left: 50vw;
  transform: translateX(-50%);
  z-index: 122;
}
.infoWindowText {
  text-decoration: none;
}


.v-application a {
  color: white!important;
}

.v-card__title {
  justify-content: center;
  font-weight: 600;
}

.drawerCard {
  position: fixed!important;
  width:100%;
  opacity: 0.9;
  overflow-y: auto!important;
  max-width: 550px!important;
  transition: height 0.3s ease, transform 0.3s ease;
  bottom: 5vh;
}

.drawer-handle {
  height: 10px;
  width: 60px;
  background-color: #333;
  border-radius: 10px;
  margin: 10px auto;
  cursor: pointer;
  z-index: 100;
  position: relative
}

/*.closedDrawer {
  transform: translateY(93%) translateX(50%);
  width: 30%;
  right: 50%;
}*/

.closedDrawer {

}

.bottomDrawerNav {
  color: #333;
  margin: 10px;
}

.bottomDrawerNavActive {
  color: #130d0d!important;
  margin: 10px;
}

.bottomDrawerNavNotActive {
  color: #4f4e4e !important;
  margin: 10px;
}

.noScroll {
  overflow-y: hidden!important;
}

.picAttribution {
  font-size: small;
  left: 10px;
  bottom: 10px;
  position: absolute;
  background-color: #333;
  opacity: 0.8;
}

.drawerTitle {
  padding-top: 0;
  padding-bottom: 20px;
  font-size: large;
}

.v-navigation-drawer {
  opacity: 0.92;
}
.bottomDrawer {
  background-color: grey;
}

.bottomBarText {
  font-size: 11px;
  font-weight: bold;
}

.map {
  width:100%;
  height: 100vh;
  position: absolute;
}
.markerChange img {
  border-radius: 50% !important;
}

</style>

